import { useEffect, useState } from "react";
import axios from "axios";
import TestFilters from "./TestFilters";
import TestList from "./TestList";

export default function TestSelectorModal({ onSelect, onClose }) {

  const API_BASE = "https://api.ilogically.com/api";
  const APP_TOKEN = "87adfacc2dffc65ae172d59a9f0badda";

  const [tests,setTests] = useState([]);
  const [loading,setLoading] = useState(false);

  const [filters,setFilters] = useState({
    testName:"",
    difficultyLevel:"",
    testLanguage:"",
    testStatus:"",
    topic_name:"",
    sectionName:"",
    limit:20,
    offset:0
  });

  async function fetchTests(){

    try{

      setLoading(true);

      const res = await axios.get(
        `${API_BASE}/tests`,
        {
          params:{
            ...filters,
            appToken:APP_TOKEN
          }
        }
      );

      setTests(res.data.items || []);

    }catch(e){

      console.error(e);

    }finally{

      setLoading(false);

    }

  }

  useEffect(()=>{
    fetchTests();
  },[filters]);



  function nextPage(){

    setFilters(prev=>({
      ...prev,
      offset: prev.offset + prev.limit
    }));

  }

  function prevPage(){

    setFilters(prev=>({
      ...prev,
      offset: Math.max(0, prev.offset - prev.limit)
    }));

  }



 return (

<div className="lmsModalOverlay">

  <div className="lmsModal">

    <div className="lmsHeader">

      <h3>Select Test</h3>

      <button
        className="closeBtn"
        onClick={onClose}
      >
        ✕
      </button>

    </div>


    <div className="filtersSection">

      <TestFilters
        filters={filters}
        setFilters={setFilters}
      />

    </div>


    <div className="testsSection">

      {loading && <div className="loading">Loading tests...</div>}

      {!loading && (

        <TestList
          tests={tests}
          onSelect={(test)=>{
            onSelect(test);
            onClose();
          }}
        />

      )}

    </div>


    <div className="paginationBar">

      <button style={{fontSize:"17px",border:"1px solid  rgba(144, 202, 249,1)"
          ,borderRadius:"5px",height:"35px"}}
        onClick={prevPage}
        disabled={filters.offset === 0}
      >
        ← Previous
      </button>

      <span>
        Page {Math.floor(filters.offset / filters.limit) + 1}
      </span>

      <button style={{fontSize:"17px",border:"1px solid  rgba(144, 202, 249,1)"
          ,borderRadius:"5px",height:"35px"}}
        onClick={nextPage}
        disabled={tests.length < filters.limit}
      >
        Next →
      </button>

    </div>

  </div>
<style>{`.lmsModalOverlay{
  position:fixed;
  inset:0;
  background:rgba(0,0,0,0.05);
  display:flex;
  align-items:center;
  justify-content:center;
 z-index:9999999 !important;
}

.lmsModal{
   position:fixed;top:50px;bottom:0px;width:85%;
  background:#fff;
  border-radius:10px;
  display:flex;
  flex-direction:column;
  overflow:hidden;
  box-shadow:0 10px 40px rgba(0,0,0,0.15);
}

.lmsHeader{
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:16px 20px;
  border-bottom:1px solid #eee;
  font-weight:600;
}

.closeBtn{
  border:none;
  background:#f5f5f5;
  width:32px;
  height:32px;
  border-radius:6px;
  cursor:pointer;
}

.closeBtn:hover{
  background:#eaeaea;
}

.filtersSection{
  padding:14px 20px;
  border-bottom:1px solid #eee;
  background:#fafafa;
}

.testsSection{
  flex:1;
  overflow:auto;
  padding:16px 20px;
}

.loading{
  text-align:center;
  padding:30px;
  color:#777;
}

.paginationBar{
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:14px 20px;
  border-top:1px solid #eee;
}

.paginationBar button{
  border:none;
  background:rgba(144, 202, 249,1);
  color:white;
  padding:8px 16px;
  border-radius:6px;
  cursor:pointer;
}

.paginationBar button:disabled{
  background:rgba(144, 202, 249,0.31);color:#777;
  cursor:not-allowed;
}

.paginationBar span{
  font-weight:500;
}`}</style>
</div>

)
}



const modalStyle={
  position:"fixed",
  top:0,
  left:0,
  right:0,
  bottom:0,
  background:"rgba(0,0,0,0.5)",
  display:"flex",
  justifyContent:"center",
  alignItems:"center"
};

const modalContent={
  background:"#fff",
  padding:20,
  width:700,
  maxHeight:"80vh",
  overflow:"auto"
};

const paginationStyle={
  display:"flex",
  justifyContent:"space-between",
  alignItems:"center",
  marginTop:15
};